/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import dayjs from "dayjs";
import Config from "data/config";

export const DATE_FORMAT = Config.dates.general_short; //   "MMM Mo, YYYY";
export const DATE_TIME_FORMAT = `${DATE_FORMAT} h:mma`;

export function formatDate (date) {
    // return moment.utc(date).local().format(Config.dates.general_long)
    return dayjs.utc(date).local().format(Config.dates.general_long);

}

export function formatDateGeneralShort (date) {
    return dayjs.utc(date).local().format(Config.dates.general_short);

}
